import React from 'react'

import { Grid, Box, Typography } from '@material-ui/core'

import { Section } from 'components'

const LoginBlock = ({ icon, title, message, children }) => (
  <Section>
    <Grid container justify="center">
      <Grid item xs={12} sm={7} md={5} lg={5}>
        <Box textAlign="center">
          <Box my={1}>
            {icon && icon}
            <Typography variant="h3">{title}</Typography>
          </Box>
          <Box my={1}>
            <Typography>{message}</Typography>
          </Box>
          <Box my={3}>{children}</Box>
        </Box>
      </Grid>
    </Grid>
  </Section>
)

export default LoginBlock
